import React , { useState , useEffect } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import { Label } from 'reactstrap';
import config from '../../../config';
import {
  UncontrolledTooltip
} from "reactstrap";
import TopHeaderPanel from '../TopHeaderPanel';
import Top_input from '../Top_input';
import Bottom_input from '../Bottom_input';
import { useSelector } from 'react-redux';

function ChatInputNode({ id, data }) {
  const {setNodes} = useReactFlow()
  const [Input_Message, setInput_Message] = useState(data.node_data.node_input[0].user_input.input_data)
  const [selected_input_param, setselected_input_param] = useState(data.node_data.node_input[1].taken_input_from)
   const [selected_output_param, setselected_output_param] = useState(data.node_data.node_input[2].send_output_to)
   


   const onchange_selected_input_param=(e)=>{
      setselected_input_param(e.target.value)
      let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[1].taken_input_from=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }

      const onchange_selected_output_param=(e)=>{
      setselected_output_param(e.target.value)


            let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[2].send_output_to=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }


  useEffect(() => {
     
  }, [])
  
 


  const handleChange = (e) => {
    const newValue = e.target.value;
    setInput_Message(newValue)

    // console.log(id)
    // Update the Input Value 
    let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
    node_data_temp.node_input[0].user_input.input_data=newValue
    node_data_temp.node_output=node_data_temp.node_input

    

    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
  };




  return (
   
    <div className='node-style'>
      <div className='thpw'>
      {data.selectedNodeId === id && <TopHeaderPanel />}
      </div>
      <div className="node">
        <div className='node_head'>
          <span><i className='ri-question-answer-line'></i></span>
          {data?.label || 'Chat Input'}
          <i
            className="mdi mdi-close"
            onClick={(e) => {
          
              e.stopPropagation();
              if (data?.onDelete) {
                data.onDelete(id);
              }
            }}
            style={{ cursor: 'pointer', marginLeft: 8 }}
          ></i>
          <p>Get chat inputs from the Playground.</p>
        </div>
        <div className='node_body'>
          {/* <Top_input selected_params={selected_input_param} onchange_selected_input_param={onchange_selected_input_param} /> */}
          <div>
            
            <label>Text</label><span className='information' id="information"><i className='ri-information-line'></i></span>
            <UncontrolledTooltip
              placement="top"
              target="information" 
              id="information"
            >
            {config.tool_tip.information_chat_input}
            </UncontrolledTooltip>
            
            {/* <input defaultValue={Input_Message} onChange={handleChange} placeholder="Message..." /> */}
            <textarea
                        onChange={handleChange}
                        defaultValue={Input_Message}
                        placeholder="Message..."
                        rows={3} 
                        style={{ width: '100%' }} 
                        className="nodrag f-10 border" 
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onDoubleClick={(e) => e.stopPropagation()}
                      />
            <Handle type="source" position={Position.Right}/>
            <Handle type="target" position={Position.Left}/>
          </div>
          <Bottom_input selected_params={selected_output_param} onchange_selected_output_param={onchange_selected_output_param} />
        </div>
        
      </div>
    </div>
  );
}

export default ChatInputNode;